import World from '../../src/legacy/World';
export default World;
